/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_TitleInputs */

const en_us2_workout_after_carry_title = /** @type {(inputs: Workout_After_Carry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring today's numbers into your plan?`)
};

const pt_br2_workout_after_carry_title = /** @type {(inputs: Workout_After_Carry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levar os valores de hoje para o plano?`)
};

const es_419_workout_after_carry_title = /** @type {(inputs: Workout_After_Carry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Llevar los números de hoy a tu plan?`)
};

const pt_pt2_workout_after_carry_title = /** @type {(inputs: Workout_After_Carry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levar os valores de hoje para o plano?`)
};

const fr_fr2_workout_after_carry_title = /** @type {(inputs: Workout_After_Carry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporter les chiffres du jour dans ton programme ?`)
};

const de_de2_workout_after_carry_title = /** @type {(inputs: Workout_After_Carry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die heutigen Werte in deinen Plan übernehmen?`)
};

const it_it2_workout_after_carry_title = /** @type {(inputs: Workout_After_Carry_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portare i valori di oggi nella scheda?`)
};

/**
* | output |
* | --- |
* | "Bring today's numbers into your plan?" |
*
* @param {Workout_After_Carry_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_title = /** @type {((inputs?: Workout_After_Carry_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_title(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_title(inputs)
	return en_us2_workout_after_carry_title(inputs)
});
export { workout_after_carry_title as "workout-after.carry_title" }